import { useState } from "react";
import { FetchResult, gql, useMutation } from "@apollo/client";
import { useToast } from "@/hooks/use-toast";

const SAVE_TASK_MUTATION = gql`
  mutation SaveTaskMutation($contactId: [String], $task: TaskDataInput) {
    saveTask(linkedContactIds: $contactId, Task: $task)
  }
`;

interface TaskDataInput {
  taskId?: string;
  title: string;
  type: string;
  assignee: string;
  owner: string;
  priority: number;
  dueDate: string;
  category: string;
  description: string;
  reference: string;
  durationTime?: string;
}

interface saveTaskQueryVariables {
  contactId: string[];
  task: TaskDataInput;
}

const errorStatus = "ERROR" as const;

interface saveTaskQueryResponse {
  saveTask: string;
}

export const useSaveTask = () => {
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();
  const [handleSaveTask] = useMutation<
    saveTaskQueryResponse,
    saveTaskQueryVariables
  >(SAVE_TASK_MUTATION);

  const saveTask = async (
    contactId: string[],
    task: TaskDataInput,

    callback?: () => void
  ) => {
    setSubmitting(true);
    try {
      const apiResponse = await handleSaveTask({
        variables: { contactId, task },
      });
      handleBadAPIResponse(apiResponse);
      setSubmitting(false);
      callback && callback();
      return apiResponse;
    } catch (e: unknown) {
      console.log("Error saving task:", e);
      toast({
        title: "Error saving task",
        description: "An error occurred while saving the task",
        variant: "destructive",
      });
      setSubmitting(false);
      return null;
    }
  };

  return { saveTask, submitting };
};

//***:cqcsContactNotes=2024-12-16=testingTesting2

const handleBadAPIResponse = (
  apiResponse: FetchResult<
    saveTaskQueryResponse,
    Record<string, unknown>,
    Record<string, unknown>
  >
) => {
  if (!apiResponse.data || !apiResponse.data.saveTask) {
    throw new Error("Error while saving task");
  }
};
